import { Theme, makeStyles, createStyles } from '@maas-components/styles'

const styles = (theme: Theme) => {
  const shell = theme.palette.shell[theme.shellMode]

  return createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      borderBottom: '1px solid #bebebe66',
      backgroundColor: shell.sidebar.background,
      [theme.breakpoints.down(1324)]: {
        width: '100%',
        height: '44px',
        overflowY: 'hidden',
        borderBottom: '1px solid #bebebe66',
      },
    },
    rootOpen: {
      justifyContent: 'space-between',
      padding: '20px 0',
      right: '0',
      backgroundColor: shell.sidebar.background,
    },
    rootClose: {
      justifyContent: 'flex-start',
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '20px',
      paddingRight: '40px',
      fontSize: '1.2rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    icon: {
      color: shell.sidebar.icon,
      '&:hover': {
        opacity: 0.8,
      },
      padding: '10px',
      borderRadius: 0,
    },
    iconOpen: {
      borderRight: 'none',
    },
    iconClosed: {
      borderRadius: 0,
      [theme.breakpoints.up(1324)]: {
        borderRight: 'none',
      },
    },
    iconArrowClosedSM: {
      marginLeft: theme.spacing(2),
      color: `${theme.palette.grey[500]}`,
    },
    iconArrowClosedMD: {
      marginLeft: -6,
      color: `${theme.palette.grey[500]}`,
    },
  })
}

export default makeStyles(styles, { name: 'MuiShellToolbar' })
